// Shared pure helper for usePaymentForm and its sub-hooks. Extracted VERBATIM
// (was a `const` inside the main hook body — closures over it worked from
// effects defined textually above it because those effects only call it
// asynchronously, after the render that defines it has already run).
export const formatErrorMessage = (message) => {
  if (!message) return message;
  // Add period if it's a sentence and doesn't end with punctuation
  if (message.length > 0 && !message.match(/[.!?]$/)) {
    return message + '.';
  }
  return message;
};
